import { Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { If, Else } from "lib/@components/switch"

export function LegislationLibraryFolderPathCrumb({ item, index, last }) {
    return (
        <Stack direction="row" alignItems="center" spacing={0.5} component="span">
            <If value={index > 0}>
                <Iconify icon="mdi:chevron-right" width={14} height={14} sx={{ color: "text.disabled" }} />
            </If>
            <If value={last}>
                <Typography variant="body2" color="text.primary" data-cy="legislation-folder-path-current">
                    {item.name}
                </Typography>
                <Else>
                    <Typography variant="body2" color="text.secondary" data-cy="legislation-folder-path-crumb">
                        {item.name}
                    </Typography>
                </Else>
            </If>
        </Stack>
    )
}
